import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import InputAdornment from "@material-ui/core/InputAdornment";
import { actions } from "../../../../redux/actions/alert";
import { AuthService } from "../../../../services/auth.service";
import { actions as shoppingCartActions } from "../../../../redux/actions/shoppingCart";
import styles from "../../../../styles/global-styles";
import AddIcon from "@material-ui/icons/Add";
import { PhonePlanService } from "../../../../services/phonePlan.service";
import { ProductService } from "../../../../services/product.service";

const useStyles = makeStyles(() => ({
  title: styles.title,
  backgroundIcon: styles.backgroundIcon,
  rightButton: styles.buttonRightHeader,
  header: styles.header,
  subtitle: styles.subtitle,
}));

const PlanInventoryBySIte = ({ addAlert, detailAlert, addItemToCart }) => {
  const { siteId } = AuthService.currentUserValue;
  const classes = useStyles();

  const [phonePlaneObject, setPhonePlanObject] = useState({ siteId });
  const [productCreated, setProductCreated] = useState(false);

  const handleInputText = ({ target: { value, name } }) =>
    setPhonePlanObject({ ...phonePlaneObject, [name]: value });

  const handleAddPhonePlanToCard = async () => {
    console.log("phoneplan", phonePlaneObject);
    /**/
    try {
      const { data } = await PhonePlanService.createPhonePlan(phonePlaneObject);
      const productBody = {
        productTypeId: "6",
        phonePlanId: data.id,
      };
      const productCreate = await ProductService.postProduct(productBody);
      addItemToCart({ item: productCreate.data, quantity: 1 });
      setProductCreated(true);
      console.log("productCreated", productCreate.data);
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs,
      });
    }
  };

  const validateInputs = () => {
    let result = true;
    const valuesArray = Object.values(phonePlaneObject);
    if (valuesArray.length && valuesArray.length === 4) {
      const inputValids = valuesArray.some((item) => item === "");
      result = inputValids;
    }
    if (productCreated) result = true;
    return result;
  };

  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        Plan tarifario
      </Typography>

      <Typography className={classes.header}>
        Ingresar los datos requeridos
      </Typography>
      <Grid
        container
        direction="row"
        justify="space-evenly"
        style={{ marginTop: 70 }}
        alignItems="flex-start"
      >
        <Grid item>
          <TextField
            name="concept"
            disabled={productCreated}
            placeholder="Concepto"
            value={phonePlaneObject.concept || ""}
            variant="outlined"
            onChange={(e) => handleInputText(e)}
            multiline
          />
        </Grid>
        <Grid item>
          <InputMask
            mask="99999"
            disabled={productCreated}
            maskChar=""
            value={phonePlaneObject.amount || ""}
            onChange={(e) => handleInputText(e)}
          >
            {() => (
              <TextField
                name="amount"
                disabled={productCreated}
                placeholder="Monto"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <InputMask
            mask="9999999999"
            disabled={productCreated}
            maskChar=""
            value={phonePlaneObject.telephone || ""}
            onChange={(e) => handleInputText(e)}
          >
            {() => (
              <TextField
                name="telephone"
                disabled={productCreated}
                placeholder="Teléfono"
                variant="outlined"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            disabled={validateInputs()}
            className={classes.rightButton}
            type="submit"
            onClick={() => handleAddPhonePlanToCard()}
            endIcon={
              <AddIcon
                className={classes.backgroundIcon}
                color="primary"
              ></AddIcon>
            }
          >
            Agregar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
  addItemToCart: shoppingCartActions.addItemToCart,
};

export default connect(null, dispatch)(PlanInventoryBySIte);
